var map = {
	"./ad.svg": "a7b2",
	"./ae.svg": "d436",
	"./af.svg": "b7a1",
	"./ag.svg": "32a6",
	"./ai.svg": "33df",
	"./al.svg": "3639",
	"./am.svg": "cb30",
	"./ao.svg": "300e",
	"./ar.svg": "9cda",
	"./as.svg": "7e72",
	"./at.svg": "4d15",
	"./au.svg": "444a",
	"./aw.svg": "d746",
	"./ax.svg": "79ef",
	"./az.svg": "31e2",
	"./ba.svg": "8b11",
	"./bb.svg": "9904",
	"./bd.svg": "f115",
	"./be.svg": "55cb",
	"./bf.svg": "1148",
	"./bg.svg": "9487",
	"./bh.svg": "be51",
	"./bi.svg": "0303",
	"./bj.svg": "38b7",
	"./bl.svg": "ab24",
	"./bm.svg": "1212",
	"./bn.svg": "1dc8",
	"./bo.svg": "957d",
	"./bq-bo.svg": "edc5",
	"./bq-sa.svg": "6ffa",
	"./bq-se.svg": "821b",
	"./br.svg": "8d78",
	"./bs.svg": "a9a3",
	"./bt.svg": "71fb",
	"./bw.svg": "b140",
	"./by.svg": "aea8",
	"./bz.svg": "a0d6",
	"./ca-bc.svg": "dc06",
	"./ca.svg": "650f",
	"./cc.svg": "c430d",
	"./cd.svg": "006a",
	"./cf.svg": "953e",
	"./ch.svg": "e005",
	"./ci.svg": "87ba",
	"./ck.svg": "992d",
	"./cl.svg": "1236",
	"./cm.svg": "0e2e",
	"./cn-ti.svg": "ef2e",
	"./cn.svg": "cf0f",
	"./co.svg": "3d35",
	"./cr.svg": "fbb9",
	"./cu.svg": "76fb",
	"./cv.svg": "b37e",
	"./cw.svg": "ccce",
	"./cx.svg": "96bc",
	"./cy-nc.svg": "355d",
	"./cz.svg": "da2b",
	"./de.svg": "93c2",
	"./dj.svg": "4cf6",
	"./dk.svg": "b8d7",
	"./dm.svg": "4366",
	"./do.svg": "cb78",
	"./dz.svg": "8456",
	"./ec-w.svg": "52c9",
	"./ec.svg": "efa5",
	"./ee.svg": "3446",
	"./eg.svg": "b90d",
	"./eh.svg": "ad01",
	"./er.svg": "ab28",
	"./es-07.svg": "dce8",
	"./es-13.svg": "e62c",
	"./es-ce.svg": "4e80",
	"./es-cn.svg": "8d789",
	"./es.svg": "b45f",
	"./et.svg": "2af2",
	"./eu.svg": "676f",
	"./fi.svg": "027f",
	"./fj.svg": "e9a1",
	"./fk.svg": "3963",
	"./flag.svg": "f203",
	"./fm.svg": "679c",
	"./fr-20r.svg": "0255",
	"./fr.svg": "95e0",
	"./ga.svg": "a9c7",
	"./gb-eng.svg": "14e2",
	"./gb-sct.svg": "1319",
	"./gb-wls.svg": "7937",
	"./gb.svg": "a2e3",
	"./gd.svg": "0e83",
	"./ge.svg": "0ae1",
	"./gg.svg": "e6c5",
	"./gh.svg": "2fb9",
	"./gi.svg": "0327",
	"./gl.svg": "20b8",
	"./gm.svg": "be97",
	"./gn.svg": "78a3",
	"./gq.svg": "a3c6",
	"./gr.svg": "283b",
	"./gt.svg": "f290",
	"./gu.svg": "a5ee",
	"./gw.svg": "78ab",
	"./hk.svg": "272f",
	"./hn.svg": "e880",
	"./hr.svg": "391d",
	"./ht.svg": "0b4b",
	"./hu.svg": "cda8",
	"./id.svg": "3459",
	"./ie.svg": "6c63",
	"./il.svg": "86b0",
	"./im.svg": "d5fe",
	"./in.svg": "aa6f",
	"./io.svg": "b307",
	"./iq.svg": "a4d0",
	"./ir.svg": "2e69",
	"./is.svg": "5772",
	"./it.svg": "b468",
	"./je.svg": "18a5",
	"./jm.svg": "bf65",
	"./jo.svg": "6a3a",
	"./jp.svg": "9810",
	"./ke.svg": "0606",
	"./kg.svg": "26c9",
	"./kh.svg": "d14e",
	"./ki.svg": "2ba7",
	"./km.svg": "3c10",
	"./kp.svg": "6f33",
	"./kr.svg": "954b",
	"./kw.svg": "181b",
	"./ky.svg": "7ef8",
	"./kz.svg": "b95e",
	"./la.svg": "647d",
	"./lb.svg": "1818",
	"./lc.svg": "0db4",
	"./li.svg": "186a",
	"./lk.svg": "5b70",
	"./lr.svg": "14ff",
	"./ls.svg": "a9b3",
	"./lt.svg": "6d49",
	"./lu.svg": "f95f",
	"./lv.svg": "2ba5",
	"./ly.svg": "88b6",
	"./ma.svg": "bab5",
	"./madeira.svg": "9edc",
	"./mc.svg": "365b",
	"./md-tr.svg": "1ed8",
	"./md.svg": "1586",
	"./me.svg": "2435",
	"./melilla.svg": "9716",
	"./mg.svg": "8055",
	"./mh.svg": "50a0",
	"./ml.svg": "a2d7",
	"./mm.svg": "7049",
	"./mn.svg": "b26f",
	"./mo.svg": "1ff6",
	"./mp.svg": "d143",
	"./mq.svg": "5e9f",
	"./mr.svg": "6481",
	"./ms.svg": "996e",
	"./mt.svg": "8baf",
	"./mu.svg": "aa17",
	"./mv.svg": "69f8",
	"./mw.svg": "8ce2",
	"./mx.svg": "a407",
	"./my.svg": "2dab",
	"./mz.svg": "bc63",
	"./na.svg": "1bc4",
	"./nato.svg": "afbc",
	"./ne.svg": "c1bf",
	"./nf.svg": "cbf1",
	"./ng.svg": "9677",
	"./ni.svg": "e6fb",
	"./nl.svg": "2cf1",
	"./no.svg": "c43d",
	"./np.svg": "6749",
	"./nr.svg": "f11b",
	"./nu.svg": "3868",
	"./nz.svg": "8356",
	"./om.svg": "8b0c",
	"./ossetia.svg": "e6a5",
	"./pa.svg": "c291",
	"./pe.svg": "fd1f",
	"./pf.svg": "3051",
	"./pg.svg": "84c3",
	"./ph.svg": "cd26",
	"./pirate.svg": "acc5",
	"./pk.svg": "a249",
	"./pl.svg": "411d",
	"./pn.svg": "a3b4",
	"./pr.svg": "99d5",
	"./ps.svg": "2508",
	"./pt-20.svg": "088c",
	"./pt.svg": "a673",
	"./pw.svg": "c8dc",
	"./py.svg": "8147",
	"./qa.svg": "1855",
	"./rapa-nui.svg": "9e65",
	"./republic-of-macedonia.svg": "317a",
	"./republic-of-the-congo.svg": "f7ba",
	"./ro.svg": "bc8a",
	"./rs.svg": "41d0",
	"./ru.svg": "fc3f",
	"./rw.svg": "9549",
	"./sa.svg": "a2b1",
	"./saint-kitts-and-nevis.svg": "9610",
	"./sardinia.svg": "2fc50",
	"./sb.svg": "ef12",
	"./sc.svg": "e481",
	"./sd.svg": "6e0c",
	"./se.svg": "c6d1",
	"./sg.svg": "7bb3",
	"./si.svg": "291f",
	"./sicily.svg": "2a41",
	"./sk.svg": "ec82",
	"./sl.svg": "9854",
	"./sm.svg": "687c",
	"./sn.svg": "a8e4",
	"./so.svg": "4b90",
	"./sr.svg": "02e2",
	"./ss.svg": "afb1",
	"./st.svg": "bf08",
	"./sv.svg": "3f04",
	"./sx.svg": "588b",
	"./sy.svg": "23ab",
	"./sz.svg": "e2d7",
	"./tc.svg": "ed93",
	"./td.svg": "0c16",
	"./tg.svg": "5fcf",
	"./th.svg": "c581",
	"./tj.svg": "d92d",
	"./tk.svg": "d53c",
	"./tl.svg": "7821",
	"./tm.svg": "40d1",
	"./tn.svg": "1ce1",
	"./to.svg": "86597",
	"./tr.svg": "6919",
	"./tt.svg": "e06f",
	"./tuvalu-1.svg": "387e",
	"./tv.svg": "3966",
	"./tw.svg": "e07f",
	"./tz.svg": "5520",
	"./ua.svg": "b997",
	"./ug.svg": "f56c",
	"./un.svg": "3ab3",
	"./us-hi.svg": "4a50",
	"./us.svg": "a513",
	"./uy.svg": "d3aa",
	"./uz.svg": "936f",
	"./va.svg": "2a6fc",
	"./vc.svg": "f51a",
	"./ve.svg": "dc84",
	"./vg.svg": "5027",
	"./vi.svg": "b180",
	"./vn.svg": "13b5",
	"./vu.svg": "4c68",
	"./ws.svg": "44a1",
	"./xk.svg": "aae6",
	"./ye.svg": "4111",
	"./za.svg": "3dd3",
	"./zm.svg": "6a4e",
	"./zw.svg": "31af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d11";